import request from '@/utils/request'

//查询参加考试人员
export function SelectExamUser(params) {
    return request({
        url: '/api/ExamPeople/GetExamUser',
        method: 'get',
        params
    })
}

//查询试卷
export function SelectExam(params) {
    return request({
        url: '/api/Exam/LoadQT',
        method: 'get',
        params
    })
}

//获取改卷教官
export function SelectDrillMaster(params) {
    return request({
        url: '/api/Exam/GetCorrectUser',
        method: 'get',
        params
    })
}

//获取试卷试题
export function SelectPaperQuestion(params) {
    return request({
        url: '/api/ExamPeople/GetAnswerRecord',
        method: 'get',
        params
    })
}

//删除试卷
export function delExam(data) {
    return request({
        url: '/api/Exam/Delete',
        method: 'post',
        data
    })
}